// Types
import { Action } from "../actions/types";

export type ManualInvoiceEmployee = {
  personGuid: string;
  firstName: string;
  lastName: string;
  status: string;
};

export type ManualInvoiceOptions = {
  planPaymentType: string;
  allowedTypes: string[];
};

export type ManualInvoiceCreated = {
  invoiceGuid: string;
  invoiceNumber: string;
  type: string;
  totalAmount: number;
  periodStartDate: string;
  periodEndDate: string;
  createdAt: string;
  sendEmail: boolean;
};

// Type state
type State = {
  employees: ManualInvoiceEmployee[];
  employeesLoaded: boolean;
  created: ManualInvoiceCreated | null;
  // Per field validation errors returned by the API, keyed by the field path it
  // reports, e.g. "Contributions[0].Amounts[1].Product".
  fieldErrors: Record<string, string>;
  // Which invoice types this company may have raised by hand, answered by the
  // invoice API rather than guessed from the company payload.
  options: ManualInvoiceOptions | null;
  optionsLoaded: boolean;
};

// Initial state
const INITIAL_STATE: State = {
  employees: [],
  employeesLoaded: false,
  created: null,
  fieldErrors: {},
  options: null,
  optionsLoaded: false,
};

export default (state: State = INITIAL_STATE, action: Action): State => {
  switch (action.type) {
    case "EDIT_MANUAL_INVOICE_EMPLOYEES":
      return {
        ...state,
        employees: Array.isArray(action.data) ? action.data : [],
        employeesLoaded: true,
      };
    case "EDIT_MANUAL_INVOICE_OPTIONS":
      return {
        ...state,
        options: action.data ?? null,
        optionsLoaded: true,
      };
    case "EDIT_MANUAL_INVOICE_CREATED":
      return { ...state, created: action.data ?? null, fieldErrors: {} };
    case "EDIT_MANUAL_INVOICE_FIELD_ERRORS":
      return { ...state, fieldErrors: action.data ?? {} };
    case "CLEAR_MANUAL_INVOICE":
      return INITIAL_STATE;
    default:
      return state;
  }
};
